import app from 'flarum/common/app';

app.initializers.add('mattoid/flarum-ext-money-history-auto', () => {
  console.log('[mattoid/flarum-ext-money-history-auto] Hello, common!');
});
